import React, { Component } from "react";
import { connect } from "react-redux";
import { Select } from "antd";
import { Input } from "antd";
import { Button } from "semantic-ui-react";
import { checkDuplicateOrders } from "../orderActions";
const Option = Select.Option;

const options = [
  { value: "blank short", label: "Blank Short" },
  {
    value: "confirmation from production",
    label: "Confirmation from Production"
  },
  { value: "request received (mail)", label: "Request Received (Mail)" },
  { value: "request received (call)", label: "Request Received (Call)" },
  {
    value: "request received (whatsapp)",
    label: "Request Received (WhatsApp)"
  },
  { value: "other", label: "Other" }
];

const actions = { checkDuplicateOrders };
const mapStateToProps = state => ({});

class OnHoldModal extends Component {
  state = {
    selectedOption: null,
    option: "",
    input: ""
  };
  handleChange = selectedOption => {
    this.setState({ selectedOption, option: selectedOption });
  };
  handleInput = e => {
    this.setState({ input: e.target.value });
  };
  handleSubmit = () => {
    const { formData, checkDuplicateOrders } = this.props;
    const { selectedOption, input, option } = this.state;
    if (option === "other") {
      Object.assign(formData, { reason: input, status: "on_hold" });
    } else {
      Object.assign(formData, {
        reason: selectedOption,
        status: "on_hold"
      });
    }
    formData["source"] = "manual";
    console.log(formData);
    checkDuplicateOrders(formData);
  };
  render() {
    const { selectedOption, input, option } = this.state;
    console.log(option);
    return (
      <div>
        <Select
          onChange={this.handleChange}
          placeholder="Select a Reason"
          style={{ width: "100%" }}
        >
          {options.map(item => {
            return (
              <Option key={item.value} label={item.label}>
                {item.value}
              </Option>
            );
          })}
        </Select>
        {option === "other" && (
          <Input.TextArea
            placeholder="Please provide additional comments"
            value={input}
            onChange={this.handleInput}
            rows={4}
            style={{ marginTop: "30px" }}
          />
        )}
        <Button
          style={{ marginTop: 30 }}
          fluid
          size="large"
          color="teal"
          disabled={
            selectedOption === null
              ? true
              : option === "other"
              ? input.length < 1
                ? true
                : false
              : false
          }
          onClick={this.handleSubmit}
        >
          Submit
        </Button>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  actions
)(OnHoldModal);
